import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Text } from "@mantine/core";

export default function VehicleCard({ info }) {
  const { t } = useTranslation();
  const formattedItems = info
    ? [
        { text: t("mixer:vehicle:make"), value: info.make },
        { text: t("mixer:vehicle:model"), value: info.model },
        { text: t("mixer:vehicle:year"), value: info.year },
        { text: t("mixer:vehicle:series"), value: info.series },
      ].filter((f) => f.value)
    : [];

  return (
    <Box
      mt="xs"
      style={{
        background: "var(--mantine-color-dark-6)",
        padding: "10px",
        borderRadius: "6px",
        border: "1px solid var(--mantine-color-dark-5)",
      }}
    >
      {formattedItems.map((m, i) => (
        <div key={i}>
          <Text c="white">
            {m.text}: {m.value || "?"}
          </Text>
        </div>
      ))}
    </Box>
  );
}
